const setCanonicalLink = () => {
    let relCanonical = '';

    if (typeof window !== 'undefined') {
        relCanonical = `${window.location.origin}${window.location.pathname}`;
    }

    return relCanonical;
};

module.exports.setCanonicalLink = setCanonicalLink;